import { put, takeEvery, all, select } from 'redux-saga/effects';
import * as constants from '../constants/forum';
import * as forumPageActions from '../actions/forum';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import { ForumService } from '../../api/forum-service';
import { Notification } from '../../components/notification/main';
import * as coreActions from '../actions/core';

import Translator from '../../core/i18n';
import { ICreateForumData } from '../../models/components/create-forum';
import { IAddForum, IGetForumMessage, IGetForumThreadById, ISendForumMessage, IDeleteForum } from '../../models/action/forum';
import { ForumThreadType } from '../../models/enums/forumThreadType';
import { CacheService } from '../../core/cacheService';
import { IActionRequestDate } from '../../models/core/action-request';
const T = Translator.create();
const _logger = Log.create('Forum Saga');
const _forumService = new ForumService();
const _cacheService = new CacheService();

const getCoursePageState = (state: { coursePage: any; }) => state.coursePage;

function* getHomePageConversation(params: any): any {
    let isError = false;
    let errorList: any;
    const cacheData: IActionRequestDate = { firstRequestDate: new Date(), actionName: params.type };

    if (!_cacheService.CheckCache(cacheData)) {
        _cacheService.AddOrUpdateActionRequest(cacheData);
        try {
            const pageData = yield _forumService.RequestGetMyConversationAsync(params.Filters).then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

            if (isError) {
                errorList ?
                    Object.keys(errorList).forEach((key: any) => {
                        Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                    }) : Notification.setNotification('error', T.t('r_forum_page_my_group_error_message'), 'topRight');
            }

            if (!isError) {
                yield put(forumPageActions.setHomePageConversationSetAction(pageData, params.spinnerId, 'set'));
            }
        } catch (error: any) {
            Notification.setNotification('error', T.t('r_forum_page_my_group_error_message') + error, 'topRight');
        }
    } else {
        try {
            const pageData = yield _forumService.RequestGetMyConversationAsync(params.Filters).then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

            if (isError) {
                errorList ?
                    Object.keys(errorList).forEach((key: any) => {
                        Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                    }) : Notification.setNotification('error', T.t('r_forum_page_my_group_error_message'), 'topRight');
            }

            if (!isError) {
                yield put(forumPageActions.setHomePageConversationSetAction(pageData, params.spinnerId, 'set'));
            }
        } catch (error: any) {
            Notification.setNotification('error', T.t('r_forum_page_my_group_error_message') + error, 'topRight');
        }
    }
}

function* getConversation(params: any): any {
    let isError = false;
    let errorList: any;
    try {

        const coursePage = yield select(getCoursePageState);
        const pageData = yield _forumService.RequestGetMyConversationAsync({ Take: params.take, Skip: params.skip, Type: params.forumType, classId: params.classId, searchedWord: params.searchedWord ? params.searchedWord : '', CourseId: coursePage.classes?.classes?.length === 0 ? params.courseId : "" }).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_forum_page_my_group_error_message'), 'topRight');
        }
        if (!isError) {
            yield put(forumPageActions.setForumConversation(pageData, params.take, params.skip, params.spinnerId, 'set'));
            if (params.callback) {
                params.callback(true);
            }
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_forum_page_my_group_error_message'), 'topRight');
    }
}

function* addForum(params: IAddForum): any {
    let isError = false;
    let errorList: any;

    try {
        const requestReturn = yield _forumService.RequestAddForum(params.addForumData)
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (!isError) {
            params.callback!(true);
            yield put(coreActions.newNotification(T.t('r_add_forum_succesful_notification'), '', '', 'topRight', 'success'));
            yield put(coreActions.setSpinner(params.spinnerId!, 'set'));
            yield put(forumPageActions.getForumConversation(15, 0, ForumThreadType.Organization, '', 'getForumConversation', 'get', undefined, undefined, undefined, params.addForumData.courseId));
        } else {
            yield put(coreActions.setSpinner(params.spinnerId!, 'set'));
        }
    } catch (error: any) {
        // catch error!
        yield put(coreActions.newNotification(T.t('r_request_error_on_forum_add') + ' ' + error, '', '', 'topRight', 'error'));
        yield put(coreActions.setSpinner(params.spinnerId!, 'set'));
    }
}

function* deleteForum(params: IDeleteForum): any {
    let isError = false;
    let errorList: any;

    try {
        const requestReturn = yield _forumService.RequestDeleteForum(params)
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
            }).then((response) => {
                if (isError) {
                    errorList = response;
                }
                return response;
            });

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (!isError) {
            yield put(coreActions.newNotification(T.t('r_forum_delete'), '', '', 'topRight', 'success'));
            yield put(forumPageActions.getForumConversation(15, 0, ForumThreadType.Organization, '', 'getForumConversation', 'get', undefined, undefined, undefined, params.courseId));
        }
    } catch (error: any) {
        // catch error!
        yield put(coreActions.newNotification(T.t('r_forum_delete') + ' ' + error, '', '', 'topRight', 'error'));
    }
}

function* getMessageData(params: any): any {
    let isError: boolean = false;
    let errorList: any;
    try {
        const requestReturn = yield _forumService.RequestGetMessageData(params)
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                }
                return response;
            });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : yield put(coreActions.newNotification(T.t('r_request_error_on_message_get'), '', '', 'topRight', 'error'));
        } else {
            yield put(forumPageActions.setMessageData(requestReturn, params.spinnerId, 'set'));
            params.callback('Edit');
        }
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('r_request_error_on_message_get'), '', '', 'topRight', 'error'));
    }
}

function* updateForumMessageData(params: any): any {
    try {
        const response: Response = yield _forumService.RequestUpdateMessageData({
            messageId: params.messageData.forumMessageId,
            threadId: params.messageData.threadId,
            isApproved: params.isApproved,
        });

        if (response.status !== 200) {
            const errorList = yield response.json();
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            return;
        }

        const responseData = yield response.json();
        if (responseData.message) {
            yield put(
                coreActions.newNotification(
                    responseData.message,
                    '',
                    '',
                    'topRight',
                    'success'
                )
            );
        }
        yield put(forumPageActions.setForumMessageUpdateData(params.messageData, params.isApproved, params.spinnerId, 'set'));
        params.callback();
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('r_request_error_on_message_get'), '', '', 'topRight', 'error'));
    }
}

function* sendMessageForum(params: ISendForumMessage): any {
    let isError = false;
    let errorList: any;
    try {
        const requestReturn = yield _forumService.RequestSendForumMessage(params)
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                } else {
                    return responseData.json();
                }
            }).then((response) => {
                if (isError) {
                    errorList = response;
                }
                return response;
            });

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (!isError) {
            yield put(coreActions.newNotification(T.t('r_forum_message_add_suuccesful'), '', '', 'topRight', 'success'));
            params.callback && requestReturn && params.callback(true, requestReturn);
        }
    } catch (error: any) {
        // catch error!
        yield put(coreActions.newNotification(T.t('r_request_error_on_forum_message_add') + ' ' + error, '', '', 'topRight', 'error'));
    }
}

function* getAnswerMessage(params: any): any {
    let isError = false;
    let errorList: any;

    try {
        const requestReturn = yield _forumService.RequestAnswerMessage(params)
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                } else {
                    return responseData.json();
                }
            }).then((response) => {
                if (isError) {
                    errorList = response;
                }
                return response;
            });

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (!isError) {
            yield put(coreActions.newNotification(T.t(params.isUpdate ? 'r_forum_message_update_succesful' : 'r_forum_message_add_suuccesful'), '', '', 'topRight', 'success'));
            if (params.callback) {
                params.callback(requestReturn);
            }
        }
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t(params.isUpdate ? 'r_forum_message_update_succesful' : 'r_forum_message_add_suuccesful') + ' ' + error, '', '', 'topRight', 'error'));
    }
}

function* deleteMessage(params: any): any {
    let isError = false;
    let errorList: any;

    try {
        const requestReturn = yield _forumService.RequestDeleteMessage(params)
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
            }).then((response) => {
                if (isError) {
                    errorList = response;
                }
                return response;
            });

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (!isError) {
            yield put(coreActions.newNotification(T.t('r_forum_message_delete_succesful'), '', '', 'topRight', 'success'));
            yield put(forumPageActions.getForumMessage(params.threadId, params.subject, 0, 10));
            params.callback();
        }
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('r_forum_message_delete_error') + ' ' + error, '', '', 'topRight', 'error'));
    }
}

function* getforumThreadById(params: IGetForumThreadById): any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _forumService.RequestGetForumthreadByIdAsync(params.forumThreadId).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_forum_page_forumthread_get_error_message'), 'topRight');
        }

        if (!isError) {
            yield put(forumPageActions.setForumThreadById(pageData, params.spinnerId!, 'set'));
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_forum_page_forumthread_get_error_message'), 'topRight');
    }
}

function* getForumMessage(params: IGetForumMessage): any {
    console.log('params getForumMessage', params);

    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _forumService.RequestGetForumMessageAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_forum_page_forummessage_error_message'), 'topRight');
        }

        if (!isError) {
            let forumMessageCount = 0;
            if (pageData && pageData[0]) {
                forumMessageCount = pageData[0].totalCount;
            }
            yield put(forumPageActions.setForumMessage(pageData, params.forumThreadId, params.forumSubject, params.isAll ? params.take * 2 : params.skip, params.take, params.spinnerId!, 'set'));
            if (params.callback) {
                let messageId = null;
                pageData.length > 0 && (messageId = '0');
                params.messageId && (messageId = params.messageId);
                params.callback(messageId);
            }
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_forum_page_forummessage_error_message'), 'topRight');
    }
}

function* getAddForumActivity(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const requestReturn = yield _forumService.RequestAddForumActivityAsync(params.forumData)
            .then((response: Response) => {
                return response;
            }).then((response: Response) => {
                if (response.status !== 200) {
                    isError = true;
                }
                return response.json();
            }).then((responseData: any) => {
                if (isError) {
                    errorList = responseData;
                }
                return responseData;
            });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : yield put(coreActions.newNotification(T.t('r_api_gen_add_activity_error'), '', '', 'topRight', 'error'));
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            if (params.callback) {
                params.callback(null);
            }
        }

        if (!isError) {
            yield put(coreActions.newNotification(T.t(!params.forumData.isUpdate ? 'r_add_activity_succesful_notification' : 'r_update_activity_succesful_notification'), '', '', 'topRight', 'success'));
            const redirectPageParams: any = {
                submitValues: params.forumData,
                activityId: params.forumData.projectActivityId ? params.forumData.projectActivityId : params.forumData.activityId ? params.forumData.activityId : requestReturn,

                termWeekId:
                    params.forumData.termWeekIds && params.forumData.termWeekIds[0] !== '0'
                        ? params.forumData.termWeekIds[0]
                        : params.forumData.termWeekIds[1]
            };
            params.callback(redirectPageParams);
        }
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t(params.forumData.isUpdate ? 'r_api_gen_update_activity_error' : 'r_api_gen_add_activity_error'), '', '', 'topRight', 'error'));
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        if (params.callback) {
            params.callback(null);
        }
    }
}

function* getForumData(params: any): any {
    let isError: boolean = false;
    let errorList: any;
    try {
        const requestReturn = yield _forumService.RequestGetForumAsync({ ...params, take: 20, skip: 0 })
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                }
                return response;
            });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : yield put(coreActions.newNotification(T.t('r_request_error_on_activity_get'), '', '', 'topRight', 'error'));
        } else {
            yield put(forumPageActions.setForumData(requestReturn[0], params.spinnerId, 'set'));
        }
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('r_request_error_on_activity_get'), '', '', 'topRight', 'error'));
    }
}

function* ratingMessage(params: any): any {
    let isError: boolean = false;
    let errorList: any;
    try {
        const requestReturn = yield _forumService.RequestGetRatingMessage(params.ratingMessageData)
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response: any) => {
                if (isError) {
                    errorList = response;
                }
                return response;
            });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : yield put(coreActions.newNotification(T.t('r_request_error_on_rate_message'), '', '', 'topRight', 'error'));
        } else {
            yield put(coreActions.newNotification(T.t('r_request_success_on_rate_message'), '', '', 'topRight', 'success'));
            params.callback();
        }
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('r_request_error_on_rate_message'), '', '', 'topRight', 'error'));
    }
}

export function* watchGetHomePageConversation() {
    yield takeEvery(constants.actions.GET_MY_GROUP, getHomePageConversation);
}

export function* watchGetConversation() {
    yield takeEvery(constants.actions.FORUM_GET_CONVERSION, getConversation);
}

export function* watchAddForum() {
    yield takeEvery(constants.actions.FORUM_ADD, addForum);
}

export function* watchGetForumMessage() {
    yield takeEvery(constants.actions.FORUM_GET_FORUMMESSAGE, getForumMessage);
}

export function* watchGetForumThreadById() {
    yield takeEvery(constants.actions.FORUM_GET_THREADBYID, getforumThreadById);
}

export function* watchSendMessageForum() {
    yield takeEvery(constants.actions.FORUM_SEND_MESSAGE, sendMessageForum);
}

export function* watchSendMessage() {
    yield takeEvery(constants.actions.FORUM_SEND_ANSWER, getAnswerMessage);
}

export function* watchDeleteForum() {
    yield takeEvery(constants.actions.FORUM_DELETE, deleteForum);
}

export function* watchGetAddForumActivity() {
    yield takeEvery(constants.actions.ADD_FORUM_ACTIVITY_GET, getAddForumActivity);
}

export function* watchGetForumData() {
    yield takeEvery(constants.actions.GET_FORUM_DATA, getForumData);
}

export function* watchGetMessageData() {
    yield takeEvery(constants.actions.GET_MESSAGE_DATA, getMessageData);
}

export function* watchUpdateForumMessageData() {
    yield takeEvery(constants.actions.UPDATE_FORUM_MESSAGE, updateForumMessageData);
}

export function* watchDeleteMessage() {
    yield takeEvery(constants.actions.FORUM_DELETE_ANSWER, deleteMessage);
}

export function* watchRatingMessage() {
    yield takeEvery(constants.actions.FORUM_RATING_MESSAGE, ratingMessage);
}

export function* ForumSagas() {
    yield all([
        watchGetHomePageConversation(),
        watchGetConversation(),
        watchAddForum(),
        watchGetForumMessage(),
        watchGetForumThreadById(),
        watchSendMessageForum(),
        watchDeleteForum(),
        watchGetAddForumActivity(),
        watchGetForumData(),
        watchSendMessage(),
        watchGetMessageData(),
        watchDeleteMessage(),
        watchRatingMessage(),
        watchUpdateForumMessageData()
    ]);
}